import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const oneSignalApi = {
  sub: (data: { oneSignalId: string }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/oneSignal/subscribe",
      method: "post",
      data,
    }),
  unSub: (data: { oneSignalId: string }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/oneSignal/unSubscribe",
      method: "delete",
      data,
    }),
};
